module.exports = __webpack_public_path__ + "img/item_origin.f524ea1a.png";